(function () {
  var L = window.EmpressPdpLib;
  if (!L) return;

  var routes = window.routes || {};

  function isTwoPiece() {
    return !!document.querySelector('.show_single_prodcut');
  }

  function selectedVariantIds() {
    if (isTwoPiece()) {
      var two = document.getElementById('selectedVariants');
      var twoVal = two && two.getAttribute('selected-variants');
      if (!twoVal) return [];
      return String(twoVal).split(',').map(function (id) { return id.trim(); }).filter(Boolean);
    }
    var input = document.querySelector('form.ProductForm [name="id"]');
    return input && input.value ? [String(input.value)] : [];
  }

  function tFrom(root) {
    return {
      free: root.getAttribute('data-free'),
      days_range: root.getAttribute('data-days-range'),
      days_one: root.getAttribute('data-days-one'),
      days_other: root.getAttribute('data-days-other')
    };
  }

  function showMessage(root, text) {
    var el = root.querySelector('[data-empress-shipping-message]');
    var results = root.querySelector('[data-empress-shipping-results]');
    results.hidden = true;
    results.innerHTML = '';
    if (!text) { el.hidden = true; el.textContent = ''; return; }
    el.hidden = false;
    el.textContent = text;
  }

  function showResults(root, html) {
    var el = root.querySelector('[data-empress-shipping-message]');
    var results = root.querySelector('[data-empress-shipping-results]');
    el.hidden = true;
    el.textContent = '';
    results.hidden = false;
    results.innerHTML = html;
  }

  function jsonFetch(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin' }, opts || {})).then(function (res) {
      return res.json().then(function (body) {
        return { ok: res.ok, status: res.status, body: body };
      }).catch(function () {
        return { ok: res.ok, status: res.status, body: {} };
      });
    });
  }

  function cartJson() {
    return jsonFetch(routes.cartUrl + '.js');
  }

  function cartClear() {
    return fetch(routes.cartUrl + '/clear.js', {
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: '{}'
    });
  }

  function cartAdd(payload) {
    return fetch(routes.cartAddUrl, {
      credentials: 'same-origin',
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function restoreCart(items) {
    function addOne(item) {
      var payload = { id: item.id, quantity: item.quantity };
      if (item.properties) payload.properties = item.properties;
      if (item.selling_plan) payload.selling_plan = item.selling_plan;
      return cartAdd(payload).then(function (res) {
        if (!res.ok) throw new Error('restore add failed');
        return res;
      });
    }
    function run() {
      return cartClear().then(function () {
        var chain = Promise.resolve();
        (items || []).forEach(function (item) {
          chain = chain.then(function () { return addOne(item); });
        });
        return chain;
      });
    }
    return run().catch(function () { return run(); });
  }

  function restoreIfCleared(cleared, snapshot, cartCount) {
    if (!cleared) return Promise.resolve();
    return restoreCart(snapshot).then(function () {
      return cartJson();
    }).then(function (checkResult) {
      if (checkResult.ok && checkResult.body.item_count !== cartCount) {
        return restoreCart(snapshot);
      }
    });
  }

  function refreshCartUi() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function ratesUrl(cep, province) {
    var url = routes.cartUrl + '/shipping_rates.json?shipping_address[zip]=' +
      encodeURIComponent(cep) + '&shipping_address[country]=Brazil';
    if (province) url += '&shipping_address[province]=' + encodeURIComponent(province);
    return url;
  }

  function needsProvince(result) {
    var raw = JSON.stringify(result.body || {}).toLowerCase();
    return !result.ok && /province|província|estado|state/.test(raw);
  }

  function viaCepProvince(cep) {
    return fetch('https://viacep.com.br/ws/' + cep + '/json/').then(function (res) {
      return res.json();
    }).then(function (data) {
      if (!data || data.erro || !data.uf) return '';
      return L.ufToProvince(data.uf);
    }).catch(function () { return ''; });
  }

  function fetchRates(cep, province) {
    return jsonFetch(ratesUrl(cep, province)).then(function (result) {
      if (result.ok) return result;
      if (province || !needsProvince(result)) return result;
      return viaCepProvince(cep).then(function (uf) {
        if (!uf) return result;
        return jsonFetch(ratesUrl(cep, uf));
      });
    });
  }

  var calculating = false;

  function calculate(root) {
    if (calculating) return Promise.resolve();
    var input = root.querySelector('#empress-pdp-cep');
    var cep = L.digitsCep(input.value);
    if (!L.isValidCep(cep)) {
      showMessage(root, root.getAttribute('data-invalid'));
      return Promise.resolve();
    }
    var ids = selectedVariantIds();
    if (!ids.length) {
      showMessage(root, root.getAttribute('data-select-size'));
      return Promise.resolve();
    }

    calculating = true;
    document.body.classList.add('empress-pdp--estimating');
    var snapshot = [];
    var cartCount = 0;
    var cleared = false;
    return cartJson().then(function (result) {
      if (!result.ok || !Array.isArray(result.body.items)) {
        throw new Error('Cart fetch failed');
      }
      snapshot = L.snapshotItems(result.body);
      cartCount = result.body.item_count || 0;
      cleared = true;
      return cartClear();
    }).then(function () {
      return cartAdd({
        items: ids.map(function (id) { return { id: Number(id), quantity: 1 }; })
      }).then(function (res) {
        return res.json().then(function (body) {
          return { ok: res.ok, body: body };
        }).catch(function () {
          return { ok: res.ok, body: {} };
        });
      });
    }).then(function (addResult) {
      if (!addResult.ok) {
        return restoreCart(snapshot).then(function () {
          return cartJson();
        }).then(function (checkResult) {
          if (checkResult.ok && checkResult.body.item_count !== cartCount) {
            return restoreCart(snapshot);
          }
        }).then(function () {
          throw new Error('Cart add failed');
        });
      }
      return fetchRates(cep);
    }).then(function (result) {
      if (!result.ok) {
        showMessage(root, root.getAttribute('data-error'));
        return;
      }
      var rates = (result.body && result.body.shipping_rates) || [];
      if (!rates.length) {
        showMessage(root, root.getAttribute('data-no-results'));
        return;
      }
      try { localStorage.setItem(L.CEP_KEY, cep); } catch (e) {}
      var formatMoney = window.Currency && window.theme ? function (cents) {
        return window.Currency.formatMoney(cents, window.theme.moneyFormat);
      } : null;
      showResults(root, L.ratesHtml(rates, tFrom(root), formatMoney));
    }).catch(function (err) {
      showMessage(root, root.getAttribute('data-error'));
    }).then(function () {
      return restoreIfCleared(cleared, snapshot, cartCount);
    }).then(function () {
      refreshCartUi();
    }).catch(function () {
      return restoreIfCleared(cleared, snapshot, cartCount).then(refreshCartUi);
    }).finally(function () {
      document.body.classList.remove('empress-pdp--estimating');
      calculating = false;
    });
  }

  function initShipping(root) {
    var input = root.querySelector('#empress-pdp-cep');
    var submit = root.querySelector('[data-empress-shipping-submit]');
    try {
      var saved = localStorage.getItem(L.CEP_KEY);
      if (saved) input.value = L.maskCep(saved);
    } catch (e) {}

    input.addEventListener('input', function () {
      input.value = L.maskCep(input.value);
    });
    submit.addEventListener('click', function () { calculate(root); });
    input.addEventListener('keydown', function (ev) {
      if (ev.key === 'Enter') { ev.preventDefault(); calculate(root); }
    });

    function onVariantChange(ev) {
      if (ev && ev.target && ev.target.closest('#empress-pdp-cep')) return;
      root.querySelector('[data-empress-shipping-results]').hidden = true;
      root.querySelector('[data-empress-shipping-results]').innerHTML = '';
      if (L.isValidCep(input.value)) calculate(root);
    }
    var form = document.querySelector('form.ProductForm');
    if (form) form.addEventListener('change', onVariantChange);
  }

  function buyBoxEl() {
    if (isTwoPiece()) {
      return document.querySelector('.buy_btns_container');
    }
    return document.getElementById('AddToCart');
  }

  function drawerOpen() {
    var d = document.getElementById('sidebar-cart');
    return !!(d && d.getAttribute('aria-hidden') === 'false');
  }

  function setChatOffset(px) {
    var chat = document.querySelector('shopify-chat');
    if (!chat) return;
    if (px) chat.style.marginBottom = px + 'px';
    else chat.style.marginBottom = '';
  }

  function setStickyVisible(sticky, on) {
    if (on) {
      sticky.hidden = false;
      sticky.setAttribute('aria-hidden', 'false');
      sticky.removeAttribute('inert');
      document.documentElement.classList.add('empress-pdp-sticky-visible');
      var h = sticky.offsetHeight;
      document.documentElement.style.setProperty('--empress-pdp-sticky-h', h + 'px');
      var waBase = document.documentElement.style.getPropertyValue('--empress-wa-base') || '20px';
      document.documentElement.style.setProperty('--empress-wa-base', waBase);
      var waFloat = document.querySelector('.whatsapp-float');
      if (waFloat) {
        waFloat.style.bottom = 'calc(' + h + 'px + ' + waBase + ')';
      }
      setChatOffset(h);
    } else {
      sticky.hidden = true;
      sticky.setAttribute('aria-hidden', 'true');
      sticky.setAttribute('inert', '');
      document.documentElement.classList.remove('empress-pdp-sticky-visible');
      document.documentElement.style.removeProperty('--empress-pdp-sticky-h');
      var waFloat = document.querySelector('.whatsapp-float');
      if (waFloat) {
        waFloat.style.bottom = '';
      }
      setChatOffset(0);
    }
  }

  function addSizeButton(host, radio) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'empress-pdp-sticky__size';
    btn.textContent = (radio.nextElementSibling && radio.nextElementSibling.textContent.trim()) || radio.value;
    btn.addEventListener('click', function () { radio.click(); });
    btn._empressRadio = radio;
    host.appendChild(btn);
  }

  function isSizeOption(radio) {
    var label = radio.closest('.SizeSwatch') || radio.closest('.ProductForm__Option');
    if (!label) return true;
    var labelText = (label.querySelector('.ProductForm__Label') || label.querySelector('legend') || {}).textContent || '';
    return /size|tamanho/i.test(labelText);
  }

  function buildSizes(sticky) {
    var host = sticky.querySelector('[data-empress-sticky-sizes]');
    host.innerHTML = '';
    if (isTwoPiece()) {
      [['.two-part-1 .SizeSwatch__Radio_custom_top', 'Top'], ['.two-part-2 .SizeSwatch__Radio_custom_bottom', 'Bottom']].forEach(function (pair) {
        var radios = document.querySelectorAll(pair[0]);
        if (!radios.length) return;
        var label = document.createElement('p');
        label.className = 'empress-pdp-sticky__group-label';
        label.textContent = pair[1];
        host.appendChild(label);
        radios.forEach(function (radio) { addSizeButton(host, radio); });
      });
      return;
    }
    document.querySelectorAll('.regular_form_Section .SizeSwatch__Radio').forEach(function (radio) {
      if (isSizeOption(radio)) addSizeButton(host, radio);
    });
  }

  function syncSizes(sticky) {
    sticky.querySelectorAll('.empress-pdp-sticky__size').forEach(function (btn) {
      var radio = btn._empressRadio;
      if (!radio) return;
      btn.classList.toggle('is-selected', radio.checked);
      btn.classList.toggle('is-unavailable', radio.disabled || radio.classList.contains('unavailable_vrnt'));
    });
  }

  function productJson() {
    var el = document.querySelector('[data-product-json]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function syncInfo(sticky) {
    var data = productJson();
    var ids = selectedVariantIds();
    var priceEl = sticky.querySelector('[data-empress-sticky-price]');
    var thumb = sticky.querySelector('[data-empress-sticky-thumb]');
    var atc = sticky.querySelector('[data-empress-sticky-atc]');
    if (isTwoPiece()) {
      var original = document.querySelector('.atc-button-new') || document.querySelector('.buy-now-button-sold-out');
      var sold = !document.querySelector('.atc-button-new') || (original && original.disabled);
      atc.disabled = sold;
      atc.textContent = sold ? (window.languages && window.languages.productFormSoldOut) : atc.getAttribute('data-label') || atc.textContent;
      var total = 0;
      ids.forEach(function (id) {
        var opt = document.querySelector('#VariantOptionsSelector option[value="' + id + '"]');
        if (opt) total += parseFloat(String(opt.getAttribute('data-price') || '0').replace('.', '').replace(',', '.')) || 0;
      });
      if (priceEl && total) priceEl.textContent = 'R$ ' + total.toFixed(2).replace('.', ',');
    } else if (data && data.product && ids[0]) {
      var variant = (data.product.variants || []).filter(function (v) { return String(v.id) === String(ids[0]); })[0];
      var originalAtc = document.getElementById('AddToCart');
      var soldReg = !originalAtc || originalAtc.disabled;
      atc.disabled = soldReg;
      atc.textContent = soldReg ? (window.languages && window.languages.productFormSoldOut) : (window.languages && window.languages.productFormAddToCart) || atc.textContent;
      if (variant && priceEl && window.Currency && window.theme) {
        priceEl.textContent = window.Currency.formatMoney(variant.price, window.theme.moneyFormat);
      }
      if (variant && thumb) {
        var img = variant.featured_image || data.product.featured_image;
        if (img && img.src) thumb.src = img.src;
      }
    }
  }

  function isMobileSticky() {
    return window.matchMedia('(max-width: 1007px)').matches;
  }

  function sizesFullySelected() {
    if (isTwoPiece()) {
      var top = document.querySelector('.two-part-1 .SizeSwatch__Radio_custom_top:checked');
      var bottom = document.querySelector('.two-part-2 .SizeSwatch__Radio_custom_bottom:checked');
      return !!(top && bottom);
    }
    var anySize = false;
    var checked = false;
    document.querySelectorAll('.regular_form_Section .SizeSwatch__Radio').forEach(function (radio) {
      if (!isSizeOption(radio)) return;
      anySize = true;
      if (radio.checked) checked = true;
    });
    return anySize ? checked : true;
  }

  function scrollToSizeOptions() {
    var target =
      document.querySelector('.two-part-1 .SizeSwatchList_custom_top') ||
      document.querySelector('.two-part-1 .ProductForm__Option_custom') ||
      document.querySelector('.two-part-1') ||
      document.querySelector('.regular_form_Section .SizeSwatchList') ||
      document.querySelector('.regular_form_Section .ProductForm__Option') ||
      document.querySelector('form.ProductForm');
    if (!target) return;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initSticky(sticky) {
    var atcLabel = sticky.querySelector('[data-empress-sticky-atc]');
    if (atcLabel) atcLabel.setAttribute('data-label', atcLabel.textContent);
    buildSizes(sticky);
    syncSizes(sticky);
    syncInfo(sticky);

    sticky.querySelector('[data-empress-sticky-atc]').addEventListener('click', function () {
      if (document.body.classList.contains('empress-pdp--estimating')) return;
      if (isMobileSticky() && !sizesFullySelected()) {
        scrollToSizeOptions();
        return;
      }
      if (isTwoPiece()) {
        var btn = document.querySelector('.atc-button-new');
        if (btn) btn.click();
      } else {
        var add = document.getElementById('AddToCart');
        if (add) add.click();
      }
    });

    var box = buyBoxEl();
    var hasIntersected = false;
    if (box && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        if (entry.isIntersecting) hasIntersected = true;
        var rect = box.getBoundingClientRect();
        var scrolledUp = hasIntersected && rect.bottom < 0;
        var show = scrolledUp && !drawerOpen();
        setStickyVisible(sticky, !!show);
      }, { threshold: 0, rootMargin: '0px' });
      io.observe(box);
    }

    var drawer = document.getElementById('sidebar-cart');
    if (drawer && window.MutationObserver) {
      new MutationObserver(function () {
        if (drawerOpen()) setStickyVisible(sticky, false);
        else if (box && hasIntersected) {
          var rect = box.getBoundingClientRect();
          var scrolledUp = rect.bottom < 0;
          setStickyVisible(sticky, scrolledUp);
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });
    }

    var form = document.querySelector('form.ProductForm');
    if (form) {
      form.addEventListener('change', function () {
        syncSizes(sticky);
        syncInfo(sticky);
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var root = document.querySelector('[data-empress-shipping]');
    if (root) initShipping(root);
    var sticky = document.querySelector('[data-empress-sticky]');
    if (sticky) initSticky(sticky);
  });
})();
